import React from 'react';
import { Link } from 'react-router-dom';

export default function AcceptTermsField({ checked, onChange, tc }) {
  const labelClass = tc?.textSec || 'text-gray-600';
  const linkClass = 'text-[#1F80FF] hover:underline font-medium';

  return (
    <label className={`flex items-start gap-2.5 text-xs leading-relaxed cursor-pointer ${labelClass}`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 h-4 w-4 rounded border-gray-400 text-[#1F80FF] focus:ring-[#1F80FF]"
        required
      />
      <span>
        Acepto los{' '}
        <Link to="/terminos" target="_blank" rel="noopener noreferrer" className={linkClass}>
          Términos de uso
        </Link>{' '}
        y la{' '}
        <Link to="/privacidad" target="_blank" rel="noopener noreferrer" className={linkClass}>
          Política de privacidad
        </Link>
        .
      </span>
    </label>
  );
}
